// Where a visit came from, for the "Source" column of Recordings and Live visitors. The browser's referrer comes first (the website that linked to the page).
// Many visits arrive WITHOUT one although they came from somewhere: an ad opened from an app, or an iPhone that hides it. For those the page's address says:
// a UTM source, or the click id an ad network adds (gclid, gbraid, wbraid for Google Ads, fbclid for Facebook, msclkid for Microsoft Ads...). Only when there
// is neither, the visit is Direct (a typed address, a bookmark, or an app that hides where the person came from).
const CLICK_IDS = [
  ['gclid', 'Google Ads'], ['gbraid', 'Google Ads'], ['wbraid', 'Google Ads'], ['gad_source', 'Google Ads'], ['dclid', 'Google Ads'],
  ['msclkid', 'Microsoft Ads'], ['fbclid', 'Facebook'], ['ttclid', 'TikTok'], ['twclid', 'X'], ['li_fat_id', 'LinkedIn'], ['epik', 'Pinterest'], ['sccid', 'Snapchat'],
];

const hostOf = (url) => {
  try { return new URL(url).host; } catch { return String(url || ''); }
};

/**
 * { name, why }: the source to show and, when it is not simply the referrer's website, one line saying how it was found (for a tooltip).
 * `referrer` and `url` (the visit's first page address) may be empty.
 */
export function visitSource({ referrer, url } = {}) {
  if (referrer) return { name: hostOf(referrer), why: referrer };
  let params = null;
  try { params = new URL(String(url || '')).searchParams; } catch { /* not an address */ }
  if (params) {
    const utm = (params.get('utm_source') || '').trim().slice(0, 60);
    if (utm) return { name: utm, why: 'The browser sent no referrer; the page address says utm_source=' + utm + '.' };
    for (const [id, name] of CLICK_IDS) {
      if (params.has(id)) return { name, why: `The browser sent no referrer (common when an ad is opened from an app, or on an iPhone), but the page address carries a ${name} click id (${id}).` };
    }
  }
  return { name: 'Direct', why: 'The browser sent no referrer and the page address has no campaign: a typed address, a bookmark, or an app that hides where the visitor came from.' };
}
